// frontend/shared-ui/src/icons/ReceiptIcon.jsx
import React from "react";

export default function ReceiptIcon({ size = 16, className = "", ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      <path d="M4 4h16v16H4z" />
      <path d="M8 10h8" />
      <path d="M8 14h5" />
    </svg>
  );
}
